export interface Point {
  x: number;
  y: number;
  pressure?: number;
}

export type ToolType = 'pen' | 'eraser' | 'rectangle' | 'circle' | 'ellipse' | 'triangle' | 'line' | 'fill' | 'note' | 'text';

export const TEXT_FONT_SIZES = [12, 14, 16, 20, 24, 32, 48];

export interface TextElement {
  id: string;
  x: number;
  y: number;
  text: string;
  color: string;
  fontSize: number;
  fontFamily: string;
}

export const NOTE_COLORS = [
  { bg: '#fef08a', border: '#facc15', label: 'Sarı' },
  { bg: '#fda4af', border: '#f43f5e', label: 'Pembe' },
  { bg: '#86efac', border: '#22c55e', label: 'Yeşil' },
  { bg: '#93c5fd', border: '#3b82f6', label: 'Mavi' },
  { bg: '#d8b4fe', border: '#a855f7', label: 'Mor' },
  { bg: '#fdba74', border: '#f97316', label: 'Turuncu' },
];

export const NOTE_W = 160;
export const NOTE_H = 100;
export const NOTE_OFFSET_X = 60;
export const NOTE_OFFSET_Y = -80;

export interface StickyNote {
  id: string;
  anchorX: number;
  anchorY: number;
  noteX: number;
  noteY: number;
  text: string;
  colorIndex: number;
}

export interface PathData {
  id: string;
  points: Point[];
  color: string;
  width: number;
  /** Per-point widths for variable pressure stroke (pen tool only) */
  widths?: number[];
  tool: ToolType;
  fill: string | null;
  opacity?: number;
}

export interface Layer {
  id: string;
  name: string;
  visible: boolean;
  locked: boolean;
  paths: PathData[];
}

export interface StoredDrawing {
  id: string;
  drawing_data: string;
  title: string | null;
  created_at: string;
  storage_path?: string;
}

export interface ProjectDrawingsProps {
  projectId: string;
}

export const CANVAS_WIDTH = 800;
export const CANVAS_HEIGHT = 500;

export type GridMode = 'none' | 'lines' | 'dots' | 'cross';
export const GRID_SIZES = [10, 20, 40, 80];
export const GRID_SIZE_LABELS = ['XS', 'S', 'M', 'L'];

export const colors = [
  '#1c1917', '#78716c', '#ef4444', '#f97316', '#f59e0b',
  '#84cc16', '#10b981', '#06b6d4', '#3b82f6', '#8b5cf6',
  '#d946ef', '#f43f5e', '#ffffff',
];

export const shapeTools: { type: ToolType; icon: string; label: string }[] = [
  { type: 'rectangle', icon: 'ri-square-line', label: 'Dörtgen' },
  { type: 'circle', icon: 'ri-circle-line', label: 'Daire' },
  { type: 'ellipse', icon: 'ri-checkbox-blank-circle-line', label: 'Elips' },
  { type: 'triangle', icon: 'ri-triangle-line', label: 'Üçgen' },
  { type: 'line', icon: 'ri-subtract-line', label: 'Çizgi' },
];

export const TRANSPARENT = 'transparent';

export const CANVAS_COLORS = [
  { id: 'white', bg: '#ffffff', border: '#e5e7eb', label: 'Beyaz' },
  { id: 'black', bg: '#1c1917', border: '#44403c', label: 'Siyah' },
  { id: 'blue', bg: '#e0f2fe', border: '#7dd3fc', label: 'Açık Mavi' },
  { id: 'yellow', bg: '#fefce8', border: '#fde047', label: 'Sarı' },
];

